import React from 'react';
import { CraneOperatorScheduleService } from '../../../services/CraneOperatorSchedules';
import SessionStorageService from '../../../services/utilities/SessionStorageService';
import { CommonHistoryDropdown } from './CommonHistoryDropdown';

/**
 * オペレータ設定履歴取得ドロップダウン
 * @param craneId {int} 揚重機ID
 * @param set {function} 選択した値
 */
export class CraneOperatorLatestRegistrationDropdown extends React.Component {
  /**
   * 履歴取得
   */
  getHistories = async fieldId => {
    if (!this.props.craneId) {
      return null;
    }

    let params = {
      field_id: fieldId,
      crane_id: this.props.craneId,
      work_hour_zone: SessionStorageService.getItem('work_hour_zone'),
    };

    return await CraneOperatorScheduleService.histories(fieldId, params).then(
      response => {
        if (response.result) {
          return response.data.entities.histories;
        } else {
          return null;
        }
      }
    );
  };

  render() {
    return (
      <CommonHistoryDropdown
        {...this.props}
        getHistories={this.getHistories}
        column={'operator_name'}
        resetKeys={[this.props.craneId]}
        inputClassName={'input-block'}
        validate={this.props.validate}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/dropdowns/single/CraneOperatorLatestRegistration.jsx